import { LocationSummary } from './LocationSummary';

export default LocationSummary;
